import React from "react";
import { Grid, makeStyles, Typography, useTheme } from "@material-ui/core";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import moment from "moment";
import clsx from "clsx";

export default function ScalingTimeline(props) {
  const { campaign } = props;

  const useStyles = makeStyles((theme) => ({
    timelineBorder: {
      borderTop: `1px solid ${theme.palette.text.disabled}`,
    },
    timelineMargin: {
      margin: "0 0 8px 0",
    },
  }));
  const classes = useStyles();

  const theme = useTheme();

  return (
    <Grid container>
      <Grid item xs={12}>
        {" "}
        {campaign.actions.length > 0 &&
          // Function: Duplicate Actions List, Sort Chronologically
          [...campaign.actions].reverse().map((action, index) => {
            let color_icon, color_text, time;

            if (action.status === "PENDING") {
              color_icon = theme.palette.warning.main;
              color_text = theme.palette.warning.dark;
              time = action.created_at;
            } else {
              color_icon = theme.palette.success.main;
              color_text = theme.palette.success.dark;
              time = action.completed_at;
            }

            return (
              <Timeline
                key={index}
                className={clsx(classes.timelineMargin, {
                  [classes.timelineBorder]: index === 0,
                })}
              >
                <TimelineItem>
                  <TimelineOppositeContent
                    style={{
                      flex: 0,
                    }}
                  />
                  <TimelineSeparator>
                    <TimelineDot
                      style={{
                        backgroundColor: color_icon,
                      }}
                    />{" "}
                    <TimelineConnector
                      style={{
                        backgroundColor: color_icon,
                      }}
                    />{" "}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="overline"
                      style={{
                        fontWeight: "bold",
                        color: color_text,
                      }}
                    >
                      {action.status}{" "}
                    </Typography>
                    <Grid
                      container
                      alignItems="flex-start"
                      justifyContent="space-between"
                    >
                      <Grid item xs={9}>
                        <Typography variant="body1">
                          {" "}
                          {action.actions}{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          variant="body1"
                          align="right"
                          color="textSecondary"
                        >
                          {moment(time).fromNow()}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </TimelineContent>{" "}
                </TimelineItem>{" "}
              </Timeline>
            );
          })}{" "}
      </Grid>{" "}
    </Grid>
  );
}
